<template>
  <div class="drops">
    <ContainerLayout :isOverview="isOverview">
      <template v-slot:contentPart>
        <component :is="dynamicComponent.content"/>
      </template>
      <template v-slot:contextActionPanel>
        <ActionPanel :selectedView="selectedView" :actions="actionsForPanel">
          <template v-slot:extraButtons >
            <ExportPackingList v-if="getSelectedResourceID.objectID !== null || selectedView === 'detail'"/>
          </template>
        </ActionPanel>
      </template>
      <template v-slot:contextPart>
        <component :is="dynamicComponent.context"/>
      </template>
    </ContainerLayout>
  </div>
</template>

<script>
import ContainerLayout from '@/components/wrld/generic/ContainerLayout'
import ActionPanel from '@/components/wrld/generic/ActionPanel'

import DropOverviewContent from '@/components/drops/DropOverviewContent'
import DropOverviewContext from '@/components/drops/DropOverviewContext'
import DropDetailContent from '@/components/drops/DropDetailContent'
import DropDetailContext from '@/components/drops/DropDetailContext'
import ExportPackingList from '@/components/drops/ExportPackingList'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Drops',
  components: {
    ContainerLayout,
    ActionPanel,
    DropOverviewContent,
    DropOverviewContext,
    DropDetailContent,
    DropDetailContext,
    ExportPackingList
  },
  props: {
    selectedView: String
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getSelectedResource',
      'getSelectedResourceID',
      'getDropDetails',
      'getContentLastUrl'
    ]),
    isOverview () {
      return this.selectedView === 'overview'
    },
    actionsForPanel () {
      let panelActions = []
      switch (this.selectedView) {
        case 'overview':
          if (this.getSelectedResourceID.objectID !== null) {
            panelActions.push(
              {
                key: 'detail',
                icon: 'fas fa-info-circle',
                name: this.$i18n.t('detail'),
                callback: this.goToDetail
              }
            )
          }
          break
        case 'detail':
          panelActions.push(
            {
              key: 'back',
              icon: 'fas fa-arrow-circle-left',
              name: this.$i18n.t('buttons.back'),
              callback: this.goToOverview
            }
          )
          panelActions.push(
            {
              key: 'detail',
              icon: 'fas fa-info-circle',
              name: this.$i18n.t('detail'),
              callback: this.goToDetail
            }
          )
          break
        default: // default is overview
          panelActions.push(
            {
              key: 'detail',
              icon: 'fas fa-info-circle',
              name: this.$i18n.t('detail'),
              callback: this.goToDetail
            }
          )
          break
      }
      return panelActions
    },
    dynamicComponent () {
      switch (this.selectedView) {
        case 'overview':
          return {
            content: 'DropOverviewContent',
            context: 'DropOverviewContext'
          }
        case 'detail':
          return {
            content: 'DropDetailContent',
            context: 'DropDetailContext'
          }
        default: // default is overview
          return {
            content: 'DropOverviewContent',
            context: 'DropOverviewContext'
          }
      }
    }
  },
  methods: {
    ...mapActions({
      clearResourceStore: 'clearResourceStore',
      setContentLastUrl: 'setContentLastUrl',
      toggleAllUnits: 'toggleAllUnits'
    }),
    goToDetail (resourceID) {
      if (this.getSelectedResourceID.objectID != null || this.getSelectedResourceID.id != null) {
        if (this.selectedView === 'overview') {
          this.setContentLastUrl({ url: this.$route.fullPath })
        }
        const dropID = this.getSelectedResource.objectID != null ? this.getSelectedResourceID.objectID : this.getSelectedResourceID.id
        this.$router.push({ name: 'DropDetail', params: { dropID } })
      }
    },
    goToOverview (resourceID) {
      const url = this.getContentLastUrl
      this.toggleAllUnits({ toggleState: 'remove' })
      if (url !== null) {
        this.$router.push({ path: url })
      } else {
        this.$router.push({ name: 'DropOverview' })
      }
    }
  },
  created () {
    this.clearResourceStore()
  }
}
</script>

<style lang="scss" scoped>
.drops {
  background-color: #FAFAFA;
}
</style>
